import {
  ProjectInterface as IProject,
  SyncAction,
} from "../../../models/interfaces/project.interface";

import { AddressInterface as IAddress } from "../../../models/interfaces/projectFormAreaCreate/parts/address.interface";
import { type } from "../../utils/util";

export class ProjectsActions {
  static V2_SET_PROJECTS = type("V2_SET_PROJECTS");
  static V2_SET_ACTIVE_PROJECT = type("V2_SET_ACTIVE_PROJECT");
  static V2_UPDATE_ACTIVE_PROJECT = type("V2_UPDATE_ACTIVE_PROJECT");
  static V2_SAVE_PROJECT_STEP = type("V2_SAVE_PROJECT_STEP");
  static V2_ADD_PROJECT = type("V2_ADD_PROJECT");
  static SET_ADDRESSES = type("SET_ADDRESSES");
  static V2_DELETE_ALL = type("V2_DELETE_ALL");
  static V2_ARCHIVE_PROJECT = type("V2_ARCHIVE_PROJECT");
  static V2_RESTORE_PROJECT = type("V2_RESTORE_PROJECT");
  static V2_ADD_OR_UPDATE_PROJECT = type("V2_ADD_OR_UPDATE_PROJECT");
  static V2_SET_SYNC_ACTION = type("V2_SET_SYNC_ACTION");
  static V2_PROJECT_LAST_SYNCED_AT = type("V2_PROJECT_LAST_SYNCED_AT");

  set(payload: { projects: IProject[] }) {
    return {
      type: ProjectsActions.V2_SET_PROJECTS,
      payload: payload,
    };
  }

  add(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_ADD_PROJECT,
      payload: payload,
    };
  }

  saveProjectStep(payload: { step: string; fields: object; valid: boolean }) {
    return {
      type: ProjectsActions.V2_SAVE_PROJECT_STEP,
      payload: payload,
    };
  }

  changeActiveProject(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_SET_ACTIVE_PROJECT,
      payload: payload,
    };
  }

  updateActiveProject(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_UPDATE_ACTIVE_PROJECT,
      payload: payload,
    };
  }

  setAddresses(payload: { addresses: IAddress[] }) {
    return {
      type: ProjectsActions.SET_ADDRESSES,
      payload: payload,
    };
  }

  deleteAll() {
    return {
      type: ProjectsActions.V2_DELETE_ALL,
    };
  }

  archiveProject(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_ARCHIVE_PROJECT,
      payload: payload,
    };
  }

  restoreProject(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_RESTORE_PROJECT,
      payload: payload,
    };
  }

  addOrUpdate(payload: { project: IProject }) {
    return {
      type: ProjectsActions.V2_ADD_OR_UPDATE_PROJECT,
      payload: payload,
    };
  }

  setSyncAction(payload: { project: IProject; action: SyncAction }) {
    return {
      type: ProjectsActions.V2_SET_SYNC_ACTION,
      payload: payload,
    };
  }

  setLastSyncedAt(payload: { project: IProject; lastSyncedAt: string }) {
    return {
      type: ProjectsActions.V2_PROJECT_LAST_SYNCED_AT,
      payload: payload,
    };
  }
}



// WEBPACK FOOTER //
// ./src/states/v2/projects/projects.actions.ts